// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_et-2";
export var aiChatCartContainerExit = "_et-4";
export var aiChatContainerLarge = "_et-0";
export var aiChatContainerSmall = "_et-1";
export var aiChatIcon = "_et-6";
export var slideInFromRight = "_et-3";
export var slideOutToRight = "_et-5";